import freqBackground from '../../../../assets/home/FreqBackground.png';
import { getFontSize } from '../../../../constants/fontSizes';

export const frequentlyAskedQuestionsSectionStyles = {
  container: {
    width: '100%',
    minHeight: {xs: '100%', lg: '100vh'},
    backgroundImage: `url(${freqBackground})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    padding: {xs: "50px 20px", lg: '80px'},
    display: 'flex',
    alignItems: 'center',
  },
  gridContainer: {
    width: '100%',
    margin: '0 auto',
  },
  leftColumn: {
    paddingRight: '40px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  header: {
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: getFontSize(24),
    lineHeight: {xs: '20px', md: '28px', lg: '35px', xl: '38px'},
    letterSpacing: '-0.02em',
    color: 'secondary.main',
  },
  title: {
    fontFamily: 'Aurora',
    fontWeight: 700,
    fontSize: getFontSize(82),
    lineHeight: {xs: '40px', md: '60px', lg: '90px', xl: '100px'},
    letterSpacing: '-0.02em',
    color: 'secondary.main',
  },
  content: {
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: getFontSize(20),
    lineHeight: {xs: '18px', md: '24px', lg: '28px', xl: '30px'},
    letterSpacing: '-0.01em',
    color: 'secondary.main',
    maxWidth: '600px',
  },
  rightColumn: {
    display: 'flex',
    alignItems: 'flex-start',
    marginTop: {xs: '20px', lg: 0},
  },
};

